import React from 'react'
import { Icon } from './Prescriptions.elements'

type Props = {
  className?: string
}

export const PrescriptionsIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 25 25"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <g clipPath="url(#clip-prescriptions)" strokeWidth="1.996">
      <rect x="10.647" y="6.128" width="12.371" height="13.432" rx="1.767" stroke="currentColor" strokeLinejoin="round"/>
      <rect x="1.457" y="6.128" width="12.371" height="13.432" rx="1.767" stroke="currentColor" strokeLinejoin="round"/>
      <rect x="5.345" y="4.714" width="13.785" height="16.259" rx="1.767" fill="#fff" stroke="currentColor" strokeLinejoin="round"/>
      <path d="M9.842 10.448l1.796 1.797 3.594-3.594" stroke="#B1B7BA"/>
      <path stroke="currentColor" d="M3.852 16.038h1.797M18.826 16.038h1.796M8.045 17.236h8.385"/>
    </g>
    <defs>
      <clipPath id="clip-prescriptions">
        <path fill="#fff" transform="translate(.259 .865)" d="M0 0h23.957v23.957H0z"/>
      </clipPath>
    </defs>
  </Icon>
)
